// Ticket #250 — mã nguồn Python của probe gửi telemetry, tách khỏi
// `telemetry-delivery-probe.ts` để mỗi file giữ một việc (và giữ file dưới 200 dòng).
//
// VÌ SAO PHẢI LÀ PYTHON, KHÔNG PHẢI Node/`fetch`/`curl`:
// hook telemetry chạy bằng `python3` TRẦN từ PATH (xem `hooks` trong
// `.claude/settings.json`). Ca 2026-08-11 (#208): Python cài từ python.org trên macOS
// KHÔNG dùng CA store hệ thống ⇒ mọi `urlopen` chết ở bắt tay TLS, trong khi `curl`
// tới CÙNG url vẫn trả 200 vì curl đọc CA của macOS. Probe bằng bất kỳ runtime nào
// khác Python sẽ cho ÂM TÍNH GIẢ — đúng cái bẫy đã đốt 5 vòng chẩn đoán.
//
// ⚠️ TRONG chuỗi template KHÔNG được có ký tự backtick — nó đóng template sớm và
// TypeScript báo lỗi cú pháp ở dòng Python, rất khó đọc. Comment Python dưới đây vì
// thế dùng dấu nháy kép thay backtick. Cũng không được có "${" (nội suy).
//
// Script in ĐÚNG MỘT dòng JSON ra stdout (`kind` + trường phụ), không bao giờ ném:
// mọi nhánh lỗi đều tự gói thành `kind`. Phân loại nằm ở `classifyProbeOutcome`
// phía TypeScript để test được không cần mạng.
//
// BẢO MẬT: token KHÔNG đi qua argv (lộ trong `ps`) và KHÔNG được in ra. Thông điệp
// lỗi cũng chỉ lấy TÊN LỚP (`type(e).__name__`) chứ không phải `str(e)` — message của
// URLError/SSLError có thể chứa URL kèm token (cùng luật với `#208`).

// Mã Python hiện chưa có escape nào nên `String.raw` bị phân tích tĩnh coi là "thừa".
// Giữ nguyên: đây là nguồn của MỘT NGÔN NGỮ KHÁC — bỏ `raw` thì lần sau ai thêm
// "\n"/"\d" vào Python sẽ bị TypeScript nuốt mất dấu gạch chéo và script hỏng IM LẶNG
// (chỉ test e2e mới bắt được). Dòng suppress phải NẰM SÁT dòng bị bắt, chen comment
// vào giữa là biome báo `suppressions/unused` và luật vẫn nổ.
// biome-ignore lint/complexity/noUselessStringRaw: raw là rào chắn cho escape thêm sau
export const TELEMETRY_DELIVERY_PROBE_PYTHON_SOURCE = String.raw`
import json, os, sys, ssl, urllib.request, urllib.error

def out(kind, **kv):
    kv["kind"] = kind
    sys.stdout.write(json.dumps(kv, ensure_ascii=False))
    sys.exit(0)

def ca_info():
    # Ca 2026-08-18: lỗi TLS chỉ nói "verify failed", KHÔNG nói CA store TRỐNG hay có
    # mà sai. Thiếu 4 số này thì chỉ dẫn phải đoán, và lần trước đoán sai đã đốt nửa
    # ngày. cafile = None nghĩa là file KHÔNG tồn tại; openssl_cafile vẫn cho biết
    # Python SẼ đọc ở đâu, tức đích cần symlink tới.
    info = {"ca_cafile": None, "ca_openssl_cafile": None, "certifi_path": None,
            "certifi_exists": False, "ca_openssl_cafile_exists": False,
            "ca_ssl_cert_file_env": os.environ.get("SSL_CERT_FILE")}
    try:
        p = ssl.get_default_verify_paths()
        info["ca_cafile"] = p.cafile
        info["ca_openssl_cafile"] = p.openssl_cafile
        # Đích CÓ file mà cafile vẫn None ⇒ Python đang bị SSL_CERT_FILE trỏ đi chỗ
        # khác, KHÔNG phải store trống. Thiếu số này thì --fix sẽ đè symlink lên một
        # cert.pem đang lành (phát hiện khi dựng e2e 2026-08-18).
        info["ca_openssl_cafile_exists"] = os.path.isfile(p.openssl_cafile or "")
    except Exception:
        pass
    try:
        import certifi
        w = certifi.where()
        info["certifi_path"] = w
        info["certifi_exists"] = os.path.exists(w)
    except Exception:
        pass
    return info

shared = os.path.join(os.environ["AVATAR_PROBE_PACK_SHARED"])
if not os.path.isdir(shared):
    out("no_pack", path=shared)
sys.path.insert(0, shared)

# Token lấy ĐÚNG bằng đường mà hook dùng (token_reader, 3 tầng: cache →
# "avatar print-id-token" → ~/.avatar/config.json). Tự đọc config ở đây sẽ đo một
# đường KHÁC đường thật ⇒ probe xanh trong khi hook vẫn 401.
try:
    import token_reader
except Exception as e:
    out("pack_import_failed", error_type=type(e).__name__)

try:
    token, _email = token_reader.get_id_token_and_email()
except Exception as e:
    out("token_read_failed", error_type=type(e).__name__)
if not token:
    out("no_token")

url = os.environ.get("AVATAR_TELEMETRY_URL", "https://telemetry.nal.vn/api/telemetry")

# Payload CỐ Ý sai schema: JSON hợp lệ nhưng không phải batch event ⇒ server chạy hết
# tầng auth rồi mới chê ở tầng validate. 422 vì thế CHỨNG MINH token hợp lệ mà KHÔNG
# ghi bất kỳ event rác nào vào DB. (route.ts: auth 401 ở d.49-61 đứng TRƯỚC parse body
# d.82-95, nên không có đường nào ra 422 mà token lại hỏng.)
body = json.dumps({"probe": "avatar-doctor"}).encode()
req = urllib.request.Request(
    url, data=body, method="POST",
    headers={"Content-Type": "application/json", "Authorization": "Bearer " + token},
)

try:
    with urllib.request.urlopen(req, timeout=8, context=ssl.create_default_context()) as r:
        out("http", status=r.getcode())
except urllib.error.HTTPError as e:
    # HTTPError phải bắt TRƯỚC URLError — nó là SUBCLASS của URLError, đảo thứ tự là
    # nuốt sạch 401/422 vào nhánh transport (cùng bẫy đã ghi ở #208).
    out("http", status=e.code)
except (urllib.error.URLError, ssl.SSLError) as e:
    # Chết TRƯỚC khi có mã HTTP: CA thiếu, DNS, proxy, cổng đóng. urlopen BỌC lỗi TLS
    # thành URLError(SSLCertVerificationError(...)) nên phải bóc "reason", nếu không
    # mọi ca đều ra "URLError" và mất đúng thông tin phân biệt CA-thiếu với mạng-đứt.
    reason = getattr(e, "reason", None)
    kind_name = type(reason).__name__ if isinstance(reason, BaseException) else type(e).__name__
    out("transport", error_type=kind_name, **ca_info())
except Exception as e:
    out("unknown", error_type=type(e).__name__)
`;
